import { computed } from 'vue'
import { useMediaQuery, onClickOutside, useEventListener } from '@vueuse/core'

export const useDynamicPanelWidth = (width, widths) => {
  const mqs = []

  if (widths.length > 0) {
    for (const [mediaQuery, width] of widths) {
      mqs.push([useMediaQuery(mediaQuery), width])
    }
  }

  const panelWidth = computed(() => {
    if (mqs.length > 0) {
      for (const [mq, width] of mqs) {
        if (mq.value) {
          return width
        }
      }
    }

    return width
  })

  return {
    panelWidth
  }
}

export const useCommonEventEmitters = (target, emits) => {
  onClickOutside(target, (event) => {
    emits('clickOutside', event)
  })

  useEventListener(document, 'keydown', (event) => {
    if (event.key === 'Escape') {
      emits('escPressed', event)
    }
  })
}
